import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectivityService } from '@klickdata/core/application/src/connectivity/connectivity.service';
import { isNetworkFailure, toSafeNetworkHttpError } from '@klickdata/core/application/src/connectivity/is-network-failure';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpConnectivityInterceptor implements HttpInterceptor {
    constructor(protected connectivity: ConnectivityService) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((err: HttpErrorResponse) => {
                if (isNetworkFailure(err)) {
                    this.connectivity.markOffline();
                    return throwError(toSafeNetworkHttpError(err));
                }
                return throwError(err);
            })
        );
    }
}
